// Senior-themed button wrapper around Polaris Button.
// Forces 48px minimum tap target via CSS (already done in senior.css).
// Wrapper exists so future senior-specific affordances (haptic-ish click
// feedback, larger touch padding mode) have a single touch point.

import { Button } from '@shopify/polaris';
import type { ComponentProps } from 'react';

interface SeniorButtonProps {
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
  size?: 'medium' | 'large';
  disabled?: boolean;
  fullWidth?: boolean;
  children: string;
  'data-testid'?: string;
}

export function SeniorButton({
  onClick,
  variant = 'secondary',
  size = 'large',
  disabled,
  fullWidth,
  children,
  ...rest
}: SeniorButtonProps) {
  const polarisVariant: ComponentProps<typeof Button>['variant'] =
    variant === 'primary' ? 'primary' : variant === 'tertiary' ? 'tertiary' : undefined;
  return (
    <Button
      onClick={onClick}
      variant={polarisVariant}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      {...rest}
    >
      {children}
    </Button>
  );
}
